module.exports = __webpack_public_path__ + "static/media/p-t.067756ce.png";